import React from "react";
import "./App.css";
import Background from "./components/Background-btns/Background_btns";
function App() {
  return (
    <div className="main-container">
      <div className="project-title">
        <h1>Groovy Background</h1>
      </div>
      <Background></Background>
    </div>
  );
}

export default App;
